import React from "react";
import BoxLoader from "../../../../general/boxLoader";
import EmptyBox from "../../../../general/emptyBox";
import PatientAllergyCardsBoxItem from "./patientAllergyCardsBox_Item";

type PatientAllergiesCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
  readonly: boolean
}

const PatientAllergyCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting,
  readonly = false
}: PatientAllergiesCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <PatientAllergyCardsBoxItem item={item} dataListTitles={dataListTitles} key={i} readonly={readonly}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default PatientAllergyCardsBox;